import {useMemo} from 'react';

import {useAccountSelectorContext} from '../../../components/Search/SearchNav/AccountSelectorContextProvider';
import {
  useStatsigGateARIAPersonalSecrets,
  useStatsigGateEnableUserSecrets,
} from '../../../util/rampFeatureFlags/rampFeatureFlags';
import {useAgentChatOrgQueryArgs} from '../useAgentChatAvailability';

export interface PersonalSecretsScope {
  organizationId: string;
  organizationName: string;
}

/**
 * usePersonalSecretsScope names the organization scoping the viewer's ARIA
 * grants on this page, or null when the panel may not manage them.
 */
export function usePersonalSecretsScope(): PersonalSecretsScope | null {
  const {orgName, skip} = useAgentChatOrgQueryArgs();
  const {selectedAccount} = useAccountSelectorContext();
  const organizationId = selectedAccount?.id;
  const ariaPersonalSecretsEnabled =
    useStatsigGateARIAPersonalSecrets(organizationId);
  const userSecretsEnabled = useStatsigGateEnableUserSecrets(organizationId);

  return useMemo(
    () =>
      !skip &&
      ariaPersonalSecretsEnabled &&
      userSecretsEnabled &&
      orgName != null &&
      organizationId != null
        ? {organizationId, organizationName: orgName}
        : null,
    [
      ariaPersonalSecretsEnabled,
      organizationId,
      orgName,
      skip,
      userSecretsEnabled,
    ]
  );
}
